export { default as degreesLocaleEs } from './localeEs';
export { default as degreesLocalePt } from './localePt';
export { default as degreesLocaleEn } from './localeEn';
